export default "__VITE_PUBLIC_ASSET__869318d1__"